export const DefaultDataSchemaFriendlyNames = {
    OneRoster10: 'IMS OneRoster 1.0',
    OneRoster11: 'IMS OneRoster 1.1',
    OneRoster12: 'IMS OneRoster 1.2',
    RankOne: 'Rank One',
    BasicRoster: 'Basic Roster',
    Clever: 'Basic Roster',
    CustomRosterData: 'Custom Roster Data'
};

export const DataSchemaFriendlyNames = {
    OneRoster10: 'OneRoster v1.0',
    OneRoster11: 'OneRoster v1.1',
    OneRoster12: 'OneRoster v1.2',
    RankOne: 'Rank One',
    BasicRoster: 'Basic Roster',
    Clever: 'Basic Roster'
};

export enum DeniedToDeleteDefualtIntegrations {
    SFTP_OneRoster10_DEFAULT = 'OneRoster10',
    SFTP_OneRoster11_DEFAULT = 'OneRoster11',
    SFTP_OneRoster12_DEFAULT = 'OneRoster12',
    SFTP_RankOne_DEFAULT = 'RankOne',
    SFTP_Clever_DEFAULT = 'Clever'
}

export class DefaultSchemaListItem {
    dname: string;
    integrationId: string;
}

export enum AllowedOnlyForVendorDataSchemaList {
    Amplify = 'Amplify',
    SchoolTube = 'SchoolTube'
}
